module.exports = __webpack_public_path__ + "static/media/applogo.c4202d96.svg";